/**
 * JetSetter-specific API service functions
 * NOTE: All API calls have been replaced with mock data
 * This file is kept for future API integration
 */

export const jetSetterService = {
  // Profile Management - DISABLED (using mock data)
  getProfile: async () => {
    // console.warn('API call disabled - using mock data');
    return Promise.resolve({});
  },

  updateProfile: async (profileData) => {
    // console.warn('API call disabled - using mock data');
    return Promise.resolve(profileData);
  },

  uploadAvatar: async (avatarFile) => {
    // console.warn('API call disabled - using mock data');
    return Promise.resolve({ avatarUrl: URL.createObjectURL(avatarFile) });
  },

  // All other methods disabled for now
  changePassword: async () => Promise.resolve({}),
  enableTwoFactor: async () => Promise.resolve({}),
  disableTwoFactor: async () => Promise.resolve({}),
  verifyTwoFactor: async () => Promise.resolve({}),
  getBookingHistory: async () => Promise.resolve([]),
  getBookingDetails: async () => Promise.resolve({}),
  cancelBooking: async () => Promise.resolve({}),
  modifyBooking: async () => Promise.resolve({}),
  downloadTicket: async () => Promise.resolve(new Blob()),
  downloadInvoice: async () => Promise.resolve(new Blob()),
  getSavedPassengers: async () => Promise.resolve([]),
  addPassenger: async () => Promise.resolve({}),
  updatePassenger: async () => Promise.resolve({}),
  deletePassenger: async () => Promise.resolve({}),
  getPaymentMethods: async () => Promise.resolve([]),
  addPaymentMethod: async () => Promise.resolve({}),
  updatePaymentMethod: async () => Promise.resolve({}),
  deletePaymentMethod: async () => Promise.resolve({}),
  setDefaultPaymentMethod: async () => Promise.resolve({}),
  getSavedCards: async () => Promise.resolve([]),
  addSavedCard: async () => Promise.resolve({}),
  deleteSavedCard: async () => Promise.resolve({}),
  getTravelPreferences: async () => Promise.resolve({}),
  updateTravelPreferences: async () => Promise.resolve({}),
  getMessages: async () => Promise.resolve([]),
  getMessage: async () => Promise.resolve({}),
  markMessageRead: async () => Promise.resolve({}),
  deleteMessage: async () => Promise.resolve({}),
  sendMessage: async () => Promise.resolve({}),
  getNotifications: async () => Promise.resolve([]),
  markNotificationRead: async () => Promise.resolve({}),
  updateNotificationSettings: async () => Promise.resolve({}),
  checkIn: async () => Promise.resolve({}),
  getBoardingPass: async () => Promise.resolve(new Blob()),
  getLoyaltyStatus: async () => Promise.resolve({}),
  getLoyaltyHistory: async () => Promise.resolve([]),
  redeemPoints: async () => Promise.resolve({})
};

export default jetSetterService;